module.exports = __webpack_public_path__ + "img/norway-other-heart-diseases-female.e676c244.png";